declare var window: any;

// var cbDispatcher: any;
var eventDispatcher;
var _clientType: any = null;

var _callbacks = {};
var _callbackId = 0;
 
window.cbDispatcher = function(...arg) {
    if (arg.length >= 2) {
        var callbackId = arg[0];
        if (callbackId) {
            var callback = _callbacks[callbackId];
            if (callback) {
                var args = Array.prototype.slice.call(arg, 1);
                callback.apply(null, args);
                delete _callbacks[callbackId];
            } else
                console.log("cbDispatcher: can not find callback function specified by callbackId " + callbackId);
        } else
            console.log("cbDispatcher: callbackId is null or undefined or empty.");
    } else
        throw "cbDispatcher: invalid arguments.";
}

window.cbDispatcher.callFuncName = "cbDispatcher";

function _postCommandToHost(...arg): any {
    if (arg.length < 1)
        throw "_postCommandToHost: invalid arguments.";
    var params = {
        cmd: '',
        cbDispatcher: '',
        callbackId: '',
        args: ''
    };
    params.cmd = arg[0];
    if (arg.length == 2) {
        var o = arg[1];
        if (o) {
            if (typeof o == 'function') {
                params.cbDispatcher = window.cbDispatcher.callFuncName;
                params.callbackId = _genCallbackId();
                _callbacks[params.callbackId] = o;
            } else {
                params.args = o;
            }
        }
    } else if (arg.length == 3) {
        var args = arg[1];
        if (args)
            params.args = args;

        var callback = arg[2];
        if (callback) {
            params.cbDispatcher = window.cbDispatcher.callFuncName;
            params.callbackId = _genCallbackId();
            _callbacks[params.callbackId] = callback;
        }
    }

    var msg = "XLH5://?" + JSON.stringify(params);
    console.log(msg);
    _postMsgToHost(msg);

}

function _registerEvents(eventNames){
    _postCommandToHost("registerEvents", { 
        eventNames: eventNames, eventDispatcher: "eventDispatcher" 
    }, function(result) {
        if (result.status !== XLH5SDK.STATUS.SUCCEED) {
            throw "Fail to register event " + result.eventName;
        }
    });
}
function _genCallbackId() {
    _callbackId++;
    return _callbackId.toString();
}

function _postMsgToAppClient(url) {
    var iFrame;
    iFrame = document.createElement("iframe");
    iFrame.setAttribute("tag", "XLH5");
    iFrame.setAttribute("src", url);
    iFrame.setAttribute("style", "display:none;");
    iFrame.setAttribute("height", "0px");
    iFrame.setAttribute("width", "0px");
    iFrame.setAttribute("frameborder", "0");
    document.body.appendChild(iFrame);
    iFrame.parentNode.removeChild(iFrame);
    iFrame = null;
    let iframes: any = document.querySelectorAll('iframe') as NodeListOf<HTMLElement>;
    for (let i = 0; i < iframes.length; i++) {
        if (iframes[i].getAttribute('tag') == 'XLH5') {
            iframes[i].parentNode.removeChild(iframes[i]);
            iframes[i] = null;
        }
    }
}

function _getClientType() {
    if (!_clientType) {
        var url: any = null;
        if (parent !== window) {
            try {
                url = parent.location.href;
            } catch (e) {
                url = document.referrer;
            }
        }
        if (url) {
            var reg = /[?&]clientType=([^?&]+)/;
            var result = url.match(reg);
            if (result) {
                _clientType = parseInt(result[1])
            }
        }
    }
}

function _postMsgToH5(msg) {
    var ifm = window.parent;
    ifm.postMessage(msg, '*');
}

function _postMsgToHost(msg){
    _getClientType();
    // 公众号 其实走的是H5的方式 ， 内嵌 iframe
    if (_clientType === 5 || _clientType === 3) {
        _postMsgToH5(msg);
    } else {
        _postMsgToAppClient(msg);
    }
}

eventDispatcher = function(eventName, data) {
    var eve = {
        e: new Event(eventName),
        data: ''
    }
    // var e = new Event(eventName);
    if (data)
    eve.data = data;
    document.dispatchEvent(eve.e);
}

let XLH5SDK = {
    STATUS: { SUCCEED: 0, FAILED: 1, UNCERTAIN: 2 },
     // 1 IOS , 2 Android , 3 H5 , 4 小游戏 , 5 微信公众号
    //电商支付
    XLShopPay: function(args, callback) {
        if (!args)
        throw "XLShopPay: args must be specified.";

        if (!args.hasOwnProperty("orderNo"))
            throw "XLShopPay: orderNo must be specified in args.";

        if (callback && typeof callback != "function")
            throw "XLShopPay: callback must be a function.";

        _postCommandToHost("XLShopPay", args, callback);
    },
    //关闭当前H5
    closeWebView: function() {
        _postCommandToHost("closeWebView");
    },
    //电商分享调用
    postMessageToApp: function(args) {
        if (!args)
            throw "postMessageToApp: args must be specified.";
        if(!args.hasOwnProperty("type"))
            throw "postMessageToApp: type must be specified in args.";
        if(!args.hasOwnProperty("action"))
            throw "postMessageToApp: action must be specified in args.";
        if(!args.hasOwnProperty("params"))
            throw "postMessageToApp: params must be specified in args.";
        _postCommandToHost("postMessageToApp",args);
    },
    getPlatform: function(callback) {
        if (callback && typeof callback != "function")
            throw "getPlatform: callback must be a function.";

        _postCommandToHost("getPlatform", callback);
    },
    init:  function() {
        var events = ["XLH5SDKbackground", "XLH5SDKforeground"];
        _registerEvents(events);
    },

    callNativeClipboard: function(args,callback){
        if (!args)
            throw "callNativeClipboard: args must be specified.";

        if (!args.hasOwnProperty("type"))
            throw "callNativeClipboard: type must be specified in args.";
        
        if (callback && typeof callback != "function")
            throw "callNativeClipboard: callback must be a function.";

        _postCommandToHost("callNativeClipboard", args, callback);
    }
    
};



export default XLH5SDK


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/com/xh5.ts